import { EventAction } from "../../mp-utils/generic-utils"
import { getWorkkeysReplaceTerm } from "../helpers/workkeysReplaceTerms"
import { ContentType } from "../types"

export enum LicenseStatus {
  LICENSED = "Licensed",
  UNLICENSED = "Unlicensed"
}

export enum GradeFilterOption {
  GRADE_9 = "9",
  GRADE_10 = "10",
  GRADE_11 = "11",
  GRADE_12 = "12"
}

export const ContentTypeLabels: Record<ContentType, string> = {
  [ContentType.bellRinger]: "Bell Ringer",
  [ContentType.practiceTest]: getWorkkeysReplaceTerm(
    ContentType.practiceTest,
    true
  ),
  [ContentType.quiz]: "Quiz",
  [ContentType.masteryLesson]: getWorkkeysReplaceTerm(
    ContentType.masteryLesson,
    true
  ),
  [ContentType.masteryCurriculum]: "Book Chapter",
  [ContentType.skillReview]: "Skill Review",
  [ContentType.digitalResource]: "Digital Resource"
}

export const ActivityEventsLabels: Record<EventAction, string> = {
  [EventAction.FINISH]: "Complete",
  [EventAction.RESUME]: "Resume",
  [EventAction.PAUSE]: "Pause",
  [EventAction.START]: "Start",
  [EventAction.ANSWER]: "Answered",
  [EventAction.VIEW]: "View",
  [EventAction.PREVIEW]: "Preview",
  [EventAction.REVIEW]: "Review",
  [EventAction.LOGIN]: "Login",
  [EventAction.LOGOUT]: "Logout",
  [EventAction.LOGOUT_INACTIVITY]: "Logout",
  [EventAction.ADD]: "Add",
  [EventAction.CREATE]: "Create",
  [EventAction.UPDATE]: "Update",
  [EventAction.DELETE]: "Delete",
  [EventAction.VERIFY]: "Verify",
  [EventAction.REGISTER]: "Register",
  [EventAction.REQUEST]: "Request",
  [EventAction.RESTORE]: "Restore",
  [EventAction.RESET]: "Reset",
  [EventAction.INIT]: "Init",
  [EventAction.DOWNLOAD]: "Download"
  // [EventAction.LESSON_COMPLETE]: "Lesson Completed",
  // [EventAction.LESSON_RESUME]: "Lesson Resumed",
  // [EventAction.LESSON_START]: "Lesson Started",
  // [EventAction.VIEW]: "Page Viewed",
  // [EventAction.QUESTION_ANSWERED]: "Question Answered"
}
